import { BrokerLicenseStatusesEnum } from 'dash-common';
import { IconKeys, mainTheme } from 'dash-ui';

export const BROKER_LICENSE_PROPS: Record<
  BrokerLicenseStatusesEnum,
  { icon: IconKeys; color: string; label: string }
> = {
  [BrokerLicenseStatusesEnum.ACTIVE]: {
    icon: 'check',
    color: mainTheme.colors.g20,
    label: 'Valid',
  },
  [BrokerLicenseStatusesEnum.INACTIVE]: {
    icon: 'close',
    color: mainTheme.colors.r20,
    label: 'Invalid',
  },
  [BrokerLicenseStatusesEnum.PENDING_REVIEW]: {
    icon: 'infoCircle',
    color: mainTheme.colors.y20,
    label: 'Pending',
  },
};
